import { Container } from "@chakra-ui/react";
import React from "react";
import BenefitData from "../../components/benefits/BenefitData";
import styles from "./benefits.module.scss";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

export type Benefit = {
  icon: string;
  title: string;
  description: string;
  customIcon?: string;
};

const benefits: Benefit[] = [
  {
    icon: "graph1",
    title: "Increased utilization",
    description:
      "10-25%* increase in plant throughput through better capacity utilization",
  },
  {
    icon: "light",
    title: "data-driven continuous improvement",
    description:
      "Identification of hot spots and opportunities for continuous improvement",
  },
  {
    icon: "clock",
    title: "Real-time information",
    description:
      "Better and informed decision making based on real-time plant status and predictions",
  },
  {
    icon: "display1",
    title: "Better overview",
    description:
      "Advanced prediction of critical operational maintenance tasks",
  },
  {
    icon: "study",
    title: "Improved learning effects",
    description:
      "Gamified training transforms boring documentation into memorable experiences that stick",
  },
  {
    title: "Faster learning curve",
    description:
      "Get your team operational in days, not months—because engaged learners absorb knowledge faster",
    customIcon: "/media/icons/exponential-curve-natural.svg",
  },
  {
    icon: "users",
    title: "Employee competency visibility",
    description:
      "Track individual skill levels and process knowledge in real-time for targeted development",
  },
];
const Benefits = () => {
  const { elementRef: titleRef, isVisible: titleVisible } = useScrollAnimation({ threshold: 0.3 });
  const { elementRef: gridRef, isVisible: gridVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <div className={`sectionContainer ${styles.benefitsContainer}`} id="benefits">
      <Container>
        <h2
          ref={titleRef}
          className={`sectionSubtitle ${styles.subtitle} fade-in ${titleVisible ? 'visible' : ''}`}
        >
          Your benefits
        </h2>
        <div
          ref={gridRef}
          className={`${styles.benefits} stagger-children ${gridVisible ? 'visible' : ''}`}
        >
          {benefits.map((benefit, index) => (
            <BenefitData data={benefit} key={index} />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Benefits;
